module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-container"
  }, [_c('van-popup', {
    staticClass: "download-pop",
    attrs: {
      "position": "top",
      "get-container": "body"
    },
    on: {
      "click": _vm.hidePop
    },
    model: {
      value: (_vm.showPop),
      callback: function($$v) {
        _vm.showPop = $$v
      },
      expression: "showPop"
    }
  }, [_c('div', {
    staticClass: "tip-box"
  }, [(_vm.showAndroidPop) ? _c('img', {
    staticClass: "android-box",
    attrs: {
      "src": require("../../image/ic_Android_ browser.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showIosPop) ? [_c('div', {
    staticClass: "safari-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../image/ic_Safari.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("请选择")]), _vm._v(" "), _c('p', [_vm._v("在Safari中打开")])]), _vm._v(" "), _c('img', {
    staticClass: "icon-line",
    attrs: {
      "src": require("../../image/ic_line.png"),
      "alt": ""
    }
  })] : _vm._e()], 2)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-00bd0e74", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bd0e74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/commonLjdsDownload.vue
// module id = 409
// module chunks = 32